'use strict';

import { fixed } from '../../utils/formater';

function Area (name, value, measure = Area.MEASURE_SQUARE_METER) {
  this.measure = measure;
  this.name = name;
  this.value = isNaN(parseFloat(value)) ? 0.0 : parseFloat(value);
}

Area.prototype.getLabel = function (name = null, measure = true) {
  const square = fixed(this.value, 1);
  const nameArea = name === null ? (this.name + ':\u00A0') : (name ? (name + ':\u00A0') : '');

  return nameArea + square + (measure ? '\u00A0' + this.measure : '');
};

Area.MEASURE_SQUARE_METER = 'м²';
Area.MEASURE_AR = 'сот.';

export default Area;



// WEBPACK FOOTER //
// ./src/classes/common/area.js